import React from 'react';
import { Blockquote } from 'flowbite-react';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

// Import CSS files for react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlideFive = () => {
    const { t, i18n } = useTranslation();

    // Slogan translation keys - these should be defined in your locale files
    const sloganKeys = [
        'slogans.success_focus',
        'slogans.every_effort',
        'slogans.knowledge_key',
        'slogans.dream_big',
        'slogans.step_by_step',
        'slogans.work_harder',
        'slogans.study_today'
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <div className='dark:bg-black'>
            <Slider {...settings}>
                {sloganKeys.map((sloganKey, index) => (
                    <div key={index}>
                        <figure className="max-w-screen-md mx-auto py-16 flex flex-col items-center dark:bg-black">
                            <Blockquote>
                                <p className="text-2xl max-md:text-xl max-md:px-2 font-bold text-black dark:text-white text-center">
                                    {t(sloganKey)}
                                </p>
                            </Blockquote>
                        </figure>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default SlideFive;